import React from 'react'
import { Control, Controller, FieldValues } from 'react-hook-form'
import { Checkbox, FormControlLabel } from '@mui/material'
import { InputProps } from '../../../store/types'

const CheckboxInput = <T extends FieldValues>({ name, control, label, rules, disabled }: InputProps<T>) => {
  return (
    <Controller
      name={name}
      control={control as Control<T>}
    
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          control={<Checkbox checked={value} onChange={onChange} id={name} disabled={disabled} />}
          label={label}
          sx={{ alignSelf: 'start' }}
        />
      )}
    />
  )
}

export default CheckboxInput
